import {
	Autocomplete,
	Button,
	FormControl,
	FormControlLabel,
	FormLabel,
	Grid,
	InputLabel,
	LinearProgress,
	MenuItem,
	Paper,
	Radio,
	RadioGroup,
	Select,
	ThemeProvider,
	TextField,
	Tooltip,
	Typography,
} from "@mui/material";
import MUIDataTable from "mui-datatables";
import IconButton from "@mui/material/IconButton";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import RemoveIcon from "@mui/icons-material/Remove";
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import { useEffect, useState } from "react";
import { getFueroTipoElevacionesEtapasProcesales } from "../../../services/FueroTipoElevacionEtapaProcesalService.js";
import { getFueros } from "../../../services/FueroService.js";
import { getFuerosSubtiposActJuzgado } from "../../../services/FueroSubtipoActJuzgadoService.js";
import FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoDialog from "./FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoDialog.jsx";
import { getFueroTipoElevacionesEtapasProcesalesSubtiposActJuzgado, getFueroTipoElevacionEtapaProcesalSubtipoActJuzgado } from "../../../services/FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoService.js";
import Message from "../../../utils/Message.jsx";
import { Box } from "@mui/system";
import React from 'react';


const initialState = {
	estado: "habilitado",
	orden: "ASC",
	ordenarPor: "descripcion_fuero",
	rows: 0,
	first: 0,
};

const estadoOptions = [
	{
		id: "todo",
		descripcion: "Todo",
	},
	{
		id: "habilitado",
		descripcion: "Habilitado",
	},
	{
		id: "deshabilitado",
		descripcion: "Deshabilitado",
	},
];

const ordenOptions = [
	{
		id: "ASC",
		descripcion: "Ascendente",
	},
	{
		id: "DESC",
		descripcion: "Descendente",
	},
];

const ordenarPorOptions = [
	{
		id: "descripcion_fuero",
		descripcion: "Fuero",
	},
	{
		id: "descripcion_tipo_elevacion",
		descripcion: "Tipo Elevación",
	},
	{
		id: "descripcion_subtipo_act_juzgado",
		descripcion: "Subtipo Actuación Juzgado",
	}
];

const nameItemsText = "Fuero Tipo Elevaciones Etapas Procesales - Subtipos Actuaciones Juzgado";
//
// ##################################################################################################################### 
//
const FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoTable = ({ ...data }) => {
	const [searchData, setSearchData] = useState(initialState);
	const [itemsCrud, setItemsCrud] = useState([]);
	const [itemCrud, setItemCrud] = useState({});
	const [actionCrud, setActionCrud] = useState("");
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [totalRowsCount, setTotalRowsCount] = useState(0);
	const [currentPage, setCurrentPage] = useState(0);
	const [openDialog, setOpenDialog] = useState(false);
	const [message, setMessage] = useState({});
	const [showMessage, setShowMessage] = useState(false);
	const [isDoingSomething, setIsDoingSomething] = useState(false);
	const [fueros, setFueros] = useState([]);
	const [valueAutoCompleteFuero, setValueAutoCompleteFuero] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteFuero, setInputValueAutoCompleteFuero] = useState("");
	const [fueroTipoElevacionesEtapasProcesales, setFueroTipoElevacionesEtapasProcesales] = useState([]);
	const [valueAutoCompleteFueroTipoElevacionEtapaProcesal, setValueAutoCompleteFueroTipoElevacionEtapaProcesal] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteFueroTipoElevacionEtapaProcesal, setInputValueAutoCompleteFueroTipoElevacionEtapaProcesal] = useState("");
	const [subtiposActJuzgado, setSubtiposActJuzgado] = useState([]);
	const [valueAutoCompleteSubtipoActJuzgado, setValueAutoCompleteSubtipoActJuzgado] = useState({
		id: "",
		label: "",
	});
	const [inputValueAutoCompleteSubtipoActJuzgado, setInputValueAutoCompleteSubtipoActJuzgado] = useState("");




	const tableColumns = [
		{
			name: "id",
			label: "ID",
			options: {
				display: "excluded",
			},
		},
		{
			name: "descripcion_fuero",
			label: "Fuero",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoFuero = itemsCrud[tableMeta.rowIndex].habilitado_fuero ? "" : "(Deshabilitado)";
					return `${value} ${habilitadoFuero}`;
				},
			},
		},

		{
			name: "descripcion_tipo_elevacion",
			label: "Tipo Elevación: Etapa Procesal",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoFueroTipoElevacion = itemsCrud[tableMeta.rowIndex].habilitado_fuero_tipo_elevacion ? "" : "(Deshabilitado)";
					const habilitadoEtapaProcesal = itemsCrud[tableMeta.rowIndex].habilitado_etapa_procesal ? "" : "(Deshabilitada)";
					const habilitadoFueroTipoElevacionEtapaProcesal = itemsCrud[tableMeta.rowIndex].habilitado_fuero_tipo_elevacion_etapa_procesal ? "" : "=>(Deshabilitado)";
					const descripcionEtapaProcesal = itemsCrud[tableMeta.rowIndex].descripcion_etapa_procesal;

					return `${value}${habilitadoFueroTipoElevacion}: ${descripcionEtapaProcesal} ${habilitadoEtapaProcesal} ${habilitadoFueroTipoElevacionEtapaProcesal}`;
				},
			},
		},
		{
			name: "descripcion_subtipo_act_juzgado",
			label: "Tipo: Subtipo Actuación Juzgado",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const habilitadoSubtipoActJuzgado = itemsCrud[tableMeta.rowIndex].habilitado_subtipo_act_juzgado ? "" : "(Deshabilitado)";
					const tipoActJuzgado = itemsCrud[tableMeta.rowIndex].descripcion_tipo_act_juzgado;
					return `${tipoActJuzgado}: ${value} ${habilitadoSubtipoActJuzgado}`;
				},
			},
		},
		{
			name: "avanzaEtapa",
			label: "Avanza Etapa",
			options: {
				filter: false,
				sort: false,
				customBodyRender: (value, tableMeta, updateValue) => {
					const avanzaEtapa = itemsCrud[tableMeta.rowIndex].avanza_etapa === true ? "Si" : "No";
					return `${avanzaEtapa}`;
				},
			},
		},
		{
			name: "actions",
			label: "Acciones",
			options: {
				filter: false,
				sort: false,
				empty: true,
				customBodyRenderLite: (dataIndex, rowIndex) => (
					<>
						{itemsCrud[dataIndex].habilitado_fuero && itemsCrud[dataIndex].habilitado_fuero_tipo_elevacion_etapa_procesal && itemsCrud[dataIndex].habilitado_subtipo_act_juzgado && itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Editar">
								<IconButton
									size="small"
									aria-label="update"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "update")}
								>
									<EditOutlinedIcon />
								</IconButton>
							</Tooltip>
						)}

						{itemsCrud[dataIndex].habilitado_fuero && itemsCrud[dataIndex].habilitado_fuero_tipo_elevacion_etapa_procesal && itemsCrud[dataIndex].habilitado_subtipo_act_juzgado && itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Deshabilitar">
								<IconButton
									size="small"
									aria-label="disable"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "disable")}
								>
									<RemoveIcon />
								</IconButton>
							</Tooltip>
						)}

						{itemsCrud[dataIndex].habilitado_fuero && itemsCrud[dataIndex].habilitado_fuero_tipo_elevacion_etapa_procesal && itemsCrud[dataIndex].habilitado_subtipo_act_juzgado && !itemsCrud[dataIndex].habilitado && (
							<Tooltip title="Habilitar">
								<IconButton
									size="small"
									aria-label="enable"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "enable")}
								>
									<AddIcon />
								</IconButton>
							</Tooltip>
						)}

						{(
							<Tooltip title="Ver">
								<IconButton
									size="small"
									aria-label="read"
									onClick={() => handleClickActionCrud(itemsCrud[dataIndex], "read")}
								>
									<ZoomInIcon />
								</IconButton>
							</Tooltip>
						)}
					</>
				),
			},
		},
	];

	const tableOptions = {
		storageKey: "my-table-state",
		rowsPerPageOptions: [10, 20, 30],
		serverSide: true,
		count: totalRowsCount,
		rowsPerPage: rowsPerPage,
		onChangeRowsPerPage: (numberOfRows) => {
			setRowsPerPage(numberOfRows);
		},
		onChangePage: (currentPage) => {
			setCurrentPage(currentPage);
		},
		download: false,
		filter: false,
		print: false,
		search: false,
		viewColumns: false,
		selectableRowsHeader: false,
		selectableRows: "none",
		elevation: 1,
		textLabels: {
			body: {
				noMatch: "No se han encontrado resultados para esta búsqueda",
			},
			pagination: {
				next: "Próxima",
				previous: "Previa",
				rowsPerPage: "Filas:",
				displayRows: "de",
			},
		},
	};

	//
	// ################################################################################
	//

	const load = async () => {
		searchData.rows = rowsPerPage;
		searchData.first = currentPage * rowsPerPage;
		searchData.sortField = searchData.ordenarPor;
		searchData.sortOrder = searchData.orden;

		setIsDoingSomething(true);
		const response = await getFueroTipoElevacionesEtapasProcesalesSubtiposActJuzgado(searchData);
		setIsDoingSomething(false);


		if (response.ok) {
			setItemsCrud(response.data.data);
			setTotalRowsCount(response.data.count);
		} else {
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//
	useEffect(() => {
		const loadFueros = async () => {
			setIsDoingSomething(true);
			const response = await getFueros({ estado: "habilitado" });
			setIsDoingSomething(false);

			if (response.ok) {
				let _response = response.data.data;
				let _Fueros = [];

				_response.forEach((item) => {
					_Fueros.push({
						id: item.id,
						label: item.descripcion,
					});
				});

				setFueros(_Fueros);
			} else {
				setFueros([]);
				setMessage({
					messageText: response.messageText,
					severity: response.messageSeverity,
				});
				setShowMessage(true);
			}
		};
		loadFueros();
	}, []);


	//
	// ################################################################################
	//

	const loadFueroTipoElevacionesEtapasProcesales = async (newValue) => {
		let _params = {
			idFuero: newValue?.id || valueAutoCompleteFuero?.id,
			idFueroTipoElevacionEtapaProcesal: newValue?.id,
			estado: searchData.estado,
			rows: rowsPerPage,
			first: currentPage * rowsPerPage,
		};
		setIsDoingSomething(true);
		const response = await getFueroTipoElevacionesEtapasProcesales(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _FueroTipoElevacionesEtapasProcesales = [];
			_response.forEach((item) => {
				_FueroTipoElevacionesEtapasProcesales.push({
					id: item.id,
					label: item.descripcion_tipo_elevacion + ': ' + item.descripcion_etapa_procesal,
				});
			});

			setFueroTipoElevacionesEtapasProcesales(_FueroTipoElevacionesEtapasProcesales);
		} else {
			setFueroTipoElevacionesEtapasProcesales([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//


	const loadSubtiposActJuzgado = async (newValue) => {
		let _params = {
			idFuero: newValue?.id || valueAutoCompleteFuero?.id,
		};
		setIsDoingSomething(true);
		const response = await getFuerosSubtiposActJuzgado(_params);
		setIsDoingSomething(false);

		if (response.ok) {
			let _response = response.data.data;
			let _SubtiposActJuzgado = [];
			_response.forEach((item) => {
				_SubtiposActJuzgado.push({
					id: item.id_subtipo_act_juzgado,
					label: item.descripcion_tipo_act_juzgado + ': ' + item.descripcion_subtipo_act_juzgado,
				});
			});

			setSubtiposActJuzgado(_SubtiposActJuzgado);
		} else {
			setSubtiposActJuzgado([]);
			setMessage({
				messageText: response.messageText,
				severity: response.messageSeverity,
			});
			setShowMessage(true);
		}
	};

	//
	// ################################################################################
	//

	useEffect(() => {
		load();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [currentPage, rowsPerPage]);

	const handleChange = (e) => {
		setSearchData({
			...searchData,
			[e.target.name]:
				e.target.type === "checkbox" ? e.target.checked : e.target.value,
		});
	};

	const handleFueroChange = (event, newValue) => {
		setValueAutoCompleteFuero(newValue);
		setSearchData({
			...searchData,
			idFuero: newValue?.id || '',
		});
		loadFueroTipoElevacionesEtapasProcesales(newValue);
		loadSubtiposActJuzgado(newValue);
	};

	const search = () => {
		setCurrentPage(0);
		load();
	};

	const clean = () => {
		setValueAutoCompleteFuero({ label: "", id: "" });
		setValueAutoCompleteFueroTipoElevacionEtapaProcesal({ label: "", id: "" });
		setValueAutoCompleteSubtipoActJuzgado({ label: "", id: "" });
		setSearchData(initialState);
		setItemsCrud([]);
		setCurrentPage(0);
		setTotalRowsCount(0);
	};

	const handleClickActionCrud = (itemCrud, action) => {
		let _itemCrud = {};

		if (action !== "create") {
			const loadItem = async () => {
				setIsDoingSomething(true);
				const response = await getFueroTipoElevacionEtapaProcesalSubtipoActJuzgado({ id: itemCrud.id });
				setIsDoingSomething(false);

				if (response.ok) {
					_itemCrud = {
						id: response.data.data.id,
						fuero: {
							id: response.data.data.id_fuero,
							label: response.data.data.descripcion_fuero,
						},
						fueroTipoElevacion: {
							id: response.data.data.id_fuero_tipo_elevacion,
							id_tipo_elevacion: response.data.data.id_tipo_elevacion,
							label: response.data.data.descripcion_tipo_elevacion,
						},
						fueroTipoElevacionEtapaProcesal: {
							id: response.data.data.id_fuero_tipo_elevacion_etapa_procesal,
							label: response.data.data.descripcion_tipo_elevacion + ': ' + response.data.data.descripcion_etapa_procesal,
						},
						subtipoActJuzgado: {
							id: response.data.data.id_subtipo_act_juzgado,
							label: response.data.data.descripcion_tipo_act_juzgado + ': ' + response.data.data.descripcion_subtipo_act_juzgado,
						},
						avanzaEtapa: response.data.data.avanza_etapa,
						observaciones: response.data.data.observaciones,
						fechaActualizacion: response.data.data.fecha_actualizacion,
						nombreUsuario: response.data.data.nombre_usuario,
						apellidoUsuario: response.data.data.apellido_usuario,
						username: response.data.data.username,
						habilitado: response.data.data.habilitado,
					};

					setActionCrud(action);
					setItemCrud(_itemCrud);
					setOpenDialog(true);
				} else {
					setMessage({
						severity: response.messageSeverity,
						messageText: response.messageText,
					});
					setShowMessage(true);
					return;
				}
			};
			loadItem();
		} else {
			_itemCrud = {
				id: '',
				fuero: {
					id: '',
					label: '',
				},
				fueroTipoElevacion: {
					id: '',
					id_tipo_elevacion: '',
					label: '',
				},
				fueroTipoElevacionEtapaProcesal: {
					id: '',
					label: '',
				},
				subtipoActJuzgado: {
					id: '',
					label: '',
				},
				avanzaEtapa: '',
				observaciones: '',
				fechaActualizacion: '',
				nombreUsuario: '',
				apellidoUsuario: '',
				username: '',
				habilitado: '',
			};

			setActionCrud(action);
			setItemCrud(_itemCrud);
			setOpenDialog(true);
		}
	};

	const handleDialogSave = () => {
		load();
		setOpenDialog(false);
	};

	const handleDialogClose = () => {
		setOpenDialog(false);
	};

	//
	// ################################################################################
	//

	// let table = data.data.table

	return (
		<>
			<Paper

				elevation={2}
			>
				<Box
					sx={{
						margin: "auto",
						width: "90%",
					}}
				>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12}>
								<h2>{nameItemsText}</h2>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="fuero"
									size="small"
									value={valueAutoCompleteFuero}
									onChange={handleFueroChange}
									inputValue={inputValueAutoCompleteFuero}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteFuero(newInputValue);
									}}
									options={fueros}
									renderInput={(params) => (
										<TextField {...params} label="Fuero" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="fueroTipoElevacionEtapaProcesal"
									size="small"
									disabled={!valueAutoCompleteFuero?.id}
									value={valueAutoCompleteFueroTipoElevacionEtapaProcesal}
									onChange={(event, newValue) => {
										setValueAutoCompleteFueroTipoElevacionEtapaProcesal(newValue);
										setSearchData({
											...searchData,
											idFueroTipoElevacionEtapaProcesal:
												newValue === null ? "" : newValue.id,
										});
									}}
									inputValue={inputValueAutoCompleteFueroTipoElevacionEtapaProcesal}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteFueroTipoElevacionEtapaProcesal(newInputValue);
									}}
									options={fueroTipoElevacionesEtapasProcesales}
									renderInput={(params) => (
										<TextField {...params} label="Tipo Elevación: Etapa Procesal" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<Autocomplete
									id="subtipoActJuzgado"
									size="small"
									disabled={!valueAutoCompleteFuero?.id}
									value={valueAutoCompleteSubtipoActJuzgado}
									onChange={(event, newValue) => {
										setValueAutoCompleteSubtipoActJuzgado(newValue);
										setSearchData({
											...searchData,
											idSubtipoActJuzgado:
												newValue === null ? "" : newValue.id,
										});
									}}
									inputValue={inputValueAutoCompleteSubtipoActJuzgado}
									onInputChange={(event, newInputValue) => {
										setInputValueAutoCompleteSubtipoActJuzgado(newInputValue);
									}}
									options={subtiposActJuzgado}
									renderInput={(params) => (
										<TextField {...params} label="Tipo: Subtipo Actuación Juzgado" />
									)}
									isOptionEqualToValue={(option, value) =>
										option.value === value.value
									}
								/>
							</Grid>
							<Grid item xs={12} md={6} lg={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="estado-select-label">Estado</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="estado"
										label="Estado"
										id="estado"
										name="estado"
										value={searchData.estado}
										size="small"
										onChange={handleChange}
									>
										{estadoOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
						</Grid>
					</Box>
					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3}>
								<FormControl sx={{ width: "100%" }}>
									<InputLabel id="ordenarPor-select-label">
										Ordenar por:
									</InputLabel>
									<Select
										sx={{ width: "100%", mr: 1 }}
										labelId="ordenarPor"
										label="Ordenar por:"
										id="ordenaPor"
										name="ordenarPor"
										value={searchData.ordenarPor}
										size="small"
										onChange={handleChange}
									>
										{ordenarPorOptions.map((item) => (
											<MenuItem key={item.id} value={item.id}>
												{item.descripcion}
											</MenuItem>
										))}
									</Select>
								</FormControl>
							</Grid>
							<Grid item xs={12} md={4}>
								<Grid container spacing={2}>
									<Grid item xs={6}>
										<FormControl component="fieldset">
											<Box display="flex" alignItems="center" sx={{ '& .MuiFormControlLabel-root': { pl: 3 } }}>
												<Typography variant="subtitle1" component="span" sx={{ ml: 1 }}>
													Ordenar
												</Typography>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(0, Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
												<RadioGroup
													aria-label="Orden"
													name="orden"
													value={searchData.orden}
													onChange={handleChange}
													row
												>
													{ordenOptions
														.slice(Math.ceil(ordenOptions.length / 2))
														.map((item) => (
															<FormControlLabel
																key={item.id}
																value={item.id}
																label={item.descripcion}
																control={<Radio />}
															/>
														))}
												</RadioGroup>
											</Box>
										</FormControl>
									</Grid>
								</Grid>
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
						<Grid container spacing={1}>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={() => handleClickActionCrud({}, "create")}
									startIcon={<AddIcon />}
								>
									Nuevo
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%", mr: 1 }}
									variant="outlined"
									size="small"
									onClick={clean}
									startIcon={<CleaningServicesIcon />}
								>
									Limpiar
								</Button>

							</Grid>
							<Grid item xs={12} md={3} lg={2}>
								<Button
									sx={{ width: "100%" }}
									variant="contained"
									size="small"
									onClick={search}
									startIcon={<SearchIcon />}
								>
									Buscar
								</Button>
							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
							<Grid item xs={12} md={3} lg={2} >
							</Grid>
						</Grid>
					</Box>

					<Box sx={{ m: 1, p: 1 }}>
					</Box>
					{isDoingSomething && <LinearProgress />}


					<MUIDataTable columns={tableColumns} data={itemsCrud} options={tableOptions} />

				</Box>
			</Paper>

			{/* >>>> Dialog */}

			{openDialog && (
				<FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoDialog
					fueros={fueros}
					fueroTipoElevacionesEtapasProcesales={fueroTipoElevacionesEtapasProcesales}
					subtiposActJuzgado={subtiposActJuzgado}
					onSave={handleDialogSave}
					onClose={handleDialogClose}
					itemCrud={itemCrud}
					actionCrud={actionCrud}
					setMessage={setMessage}
					setShowMessage={setShowMessage}
				/>
			)}

			{/* >>>> Messages */}

			{showMessage && (
				<Message
					showMessage={showMessage}
					setShowMessage={setShowMessage}
					message={message}
				/>
			)}
		</>
	);
};

export default FueroTipoElevacionEtapaProcesalSubtipoActJuzgadoTable;
